export const faq = {
  badge: "FAQ",
  title: "Questions fréquentes",
  subtitle: "Tout ce que vous devez savoir sur DONKEY TRAVEL",
  items: {
    q1: {
      question: "Comment fonctionne le système de Nuits ?",
      answer:
        "C'est un échange direct entre deux propriétaires. Vous vous mettez d'accord sur les dates (simultanées ou différées) et les modalités. Pas de points, pas de calculs compliqués, juste de l'humain.",
    },
    q2: {
      question: "Dois-je échanger en même temps ?",
      answer:
        "Non ! C'est tout l'intérêt de notre système flexible. Vous pouvez accueillir Jean en avril et aller chez lui en octobre. Cela permet aussi de se rencontrer lors de la remise des clés !",
    },
    q3: {
      question: "Comment sont vérifiés les membres ?",
      answer:
        "Tous les membres doivent être propriétaires Airbnb vérifiés. Nous vérifions également l'identité, le logement et les avis Airbnb de chaque membre pour garantir la sécurité de la communauté.",
    },
    q4: {
      question: "Que se passe-t-il en cas de problème ?",
      answer:
        "Notre équipe support est disponible 7j/7 pour vous accompagner. De plus, notre système d'avis et de notation permet de maintenir une communauté de confiance et de résoudre rapidement tout problème.",
    },
    q5: {
      question: "Y a-t-il des frais cachés ?",
      answer:
        "Non, aucun frais caché. Vous payez uniquement votre abonnement annuel selon la zone géographique choisie. Les échanges sont ensuite totalement gratuits, sans commission ni frais supplémentaires.",
    },
    q6: {
      question: "Puis-je choisir qui séjourne chez moi ?",
      answer:
        "Absolument ! Vous avez le contrôle total. Vous pouvez consulter les profils, lire les avis et accepter ou refuser chaque demande d'échange selon vos préférences.",
    },
    q7: {
      question: "Mon logement est-il assuré pendant les échanges ?",
      answer:
        "Oui, tous les échanges sont couverts par notre assurance partenaire. De plus, nous recommandons de vérifier votre assurance habitation pour une protection optimale.",
    },
    q8: {
      question: "Combien de temps à l'avance dois-je réserver ?",
      answer:
        "Cela dépend de chaque propriétaire. Certains acceptent des réservations de dernière minute, d'autres préfèrent planifier plusieurs mois à l'avance. Nous recommandons de réserver au moins 2-3 semaines à l'avance.",
    },
  },
  cta: {
    title: "Vous avez d'autres questions ?",
    subtitle:
      "Notre équipe est là pour vous aider à démarrer votre aventure DONKEY TRAVEL",
    button: "Contactez-nous",
  },
};
